<template>
  <ul v-if="isAdmin" class="header-nav">
    <li>
      <RouterLink to="/applications/list">Заявки</RouterLink>
    </li>
    <li>
      <RouterLink to="/applications/history">История изменений</RouterLink>
    </li>
  </ul>
  <ul v-else class="header-nav">
    <li>
      <RouterLink to="/applications/list">Заявки</RouterLink>
    </li>
    <li v-if="isTradeRegion">
      <RouterLink :to="goToRequestsInWork">Заявки в работе</RouterLink>
    </li>
    <li v-if="isTradeRegion">
      <RouterLink to="/common-requests/list">Общие заявки</RouterLink>
    </li>
    <li v-if="isTrade">
      <RouterLink to="/cross-analytics">Сквозная аналитика</RouterLink>
    </li>
    <li>
      <RouterLink to="/applications/list?states=suspended,rejected"
        >Приостановленное</RouterLink
      >
    </li>
    <li>
      <RouterLink to="/routes/list">Маршруты</RouterLink>
    </li>
  </ul>
</template>

<script setup>
import { computed } from 'vue'
import useAuth from '@/utils/useAuth'

const props = defineProps({
  roles: {
    type: Array,
    default: () => [],
  },
})

const { me } = useAuth()

const isAdmin = computed(() =>
  props.roles.some((r) => ['adminsales', 'admintrade'].includes(r))
)
const isTrade = computed(() =>
  props.roles.some((r) =>
    [
      'tradecentral',
      'traderegion',
      'trademacro',
      'merchmacro',
      'ldfd',
    ].includes(r)
  )
)
const isTradeRegion = computed(() => props.roles.includes('traderegion'))

const goToRequestsInWork = computed(() => {
  const userId = me.value?.id
  return {
    name: 'RequestsView',
    query: {
      states: 'work',
      'me.assignee': false,
      assigned_id: userId,
    },
  }
})
</script>

<style lang="scss" scoped>
.header {
  &-nav {
    @include reset-list;
    display: flex;
    gap: 8px 16px;
    align-items: center;
    flex-wrap: wrap;
    justify-content: flex-end;
    @include mobile {
      gap: 8px;
    }
    li {
      white-space: nowrap;
    }
  }
}
</style>
